<template>
  <v-list-item ripple @click="toggle">
    <v-list-item-action>
      <v-icon :color="selectedList.length > 0 ? 'primary' : ''">
        {{ icon }}
      </v-icon>
    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-title> Select All </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import Vue from 'vue'
import {
  VIcon,
  VListItem,
  VListItemAction,
  VListItemContent,
  VListItemTitle,
} from 'vuetify/lib'

export default Vue.extend({
  name: 'SelectAll',
  components: {
    VListItem,
    VListItemAction,
    VListItemContent,
    VListItemTitle,
    VIcon,
  },
  props: {
    fullList: { type: Array, required: true },
    selectedList: { type: Array, required: true },
  },
  computed: {
    allSelected() {
      return this.selectedList.length === this.fullList.length
    },
    someSelected() {
      return this.selectedList.length > 0 && !this.allSelected
    },
    icon() {
      if (this.allSelected) return '$checkboxOn'
      if (this.someSelected) return '$checkboxIndeterminate'
      return '$checkboxOff'
    },
  },
  methods: {
    toggle() {
      this.$nextTick(() => {
        let tempSelectedList = []
        if (!this.allSelected) {
          let newList = []
          if (typeof this.fullList[0] === 'string') {
            newList = this.fullList
          } else {
            this.fullList.forEach((arrayItem) => {
              newList.push(Object.values(arrayItem)[0])
            })
          }
          tempSelectedList = newList
        }
        this.$emit('update-selected-list', tempSelectedList)
      })
    },
  },
})
</script>
